<template>
  <div id="main-wrapper" :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'">
    <NavbarDark />

    <div class="page-title" :class="{ 'ltr': $i18n.locale === 'en', 'rtl': $i18n.locale === 'ar' }">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <h2 class="ipt-title">{{ pageTitle }}</h2>
          </div>
        </div>
      </div>
    </div>

    <section>
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-12 col-md-6">
            <div v-html="pageContent"></div>
          </div>
        </div>
      </div>
    </section>

    <FooterTop :bg="'theme-bg'" />
    <FooterDark />
    <ScrollToTop />
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import axios from 'axios';

import NavbarDark from '@/components/navbar/navbar-dark.vue';
import FooterTop from '@/components/footer/footer-top.vue';
import FooterDark from '@/components/footer/footer-dark.vue';
import ScrollToTop from '@/components/scroll-to-top.vue';
const { locale } = useI18n();
const pageContent = ref('');
const pageTitle = computed(() => {
  return locale.value === 'ar' ? 'حذف الحساب' : 'Delete account';
});

const fetchPageContent = async () => {
  try {
    const response = await axios.get('/get-pages', {
      headers: {
        'locale': locale.value
      }
    });
    const pages = response.data.pages;
    const expectedPageName = locale.value === 'ar' ? 'حذف الحساب' : 'Delete account';
    const targetPage = pages.find(
        (page) => page.page_name.trim().toLowerCase() === expectedPageName
    );

    if (targetPage) {
      pageContent.value = targetPage.page_content;
    } else {
      pageContent.value = '<p>Delete Account content not found.</p>';
    }
  } catch (error) {
    console.error('Error fetching page content:', error);
    pageContent.value = '<p>Error loading content.</p>';
  }
};

onMounted(() => {
  fetchPageContent();
});
</script>

<style scoped>
.story-wrap p {
  margin-bottom: 1rem;
  line-height: 1.8;
  font-size: 1rem;
}
</style>
